import { render, staticRenderFns } from "./decoration10.vue?vue&type=template&id=4423e06d&scoped=true"
import script from "./decoration10.vue?vue&type=script&lang=js"
export * from "./decoration10.vue?vue&type=script&lang=js"
import style0 from "./decoration10.vue?vue&type=style&index=0&id=4423e06d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423e06d",
  null
  
)

export default component.exports